import { useMemo } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const IsCurrentPath = (pathName) => {
    const location = useLocation();
    return location.pathname === pathName
};
